import { useCrypto } from '@/infra/crypto'

/**
 * Returns true when the encryption keyring is loaded,
 * indicating E2E encryption is active.
 * Used for lock indicator rendering in dialog titles.
 */
export function useEncryptionIndicator(): boolean {
  const { keyRingStatus } = useCrypto()
  return keyRingStatus === 'loaded'
}
